export const GoogleWorkspaceAppMessages = {
  AppRoute: 'APP_ROUTE',
  DisplayMode: 'DISPLAY_MODE',
  ChangeDisplayMode: 'CHANGE_DISPLAY_MODE',
  WindowHeight: 'WINDOW_HEIGHT',
  NextPage: 'NEXT_PAGE',
  SignupCompleted: 'SIGNUP_COMPLETED',
  RedirectUrl: 'REDIRECT_URL',
  AppData: 'APP_DATA',
  AppDataSuccess: 'APP_DATA_SUCCESS',
  AppDataError: 'APP_DATA_ERROR',
  FetchSpreadsheetHeaders: 'FETCH_SPREADSHEET_HEADERS',
  FetchSpreadsheetHeadersSuccess: 'FETCH_SPREADSHEET_HEADERS_SUCCESS',
  FetchSpreadsheetHeadersError: 'FETCH_SPREADSHEET_HEADERS_ERROR',
  FetchSpreadsheetData: 'FETCH_SPREADSHEET_DATA',
  FetchSpreadsheetDataSuccess: 'FETCH_SPREADSHEET_DATA_SUCCESS',
  FetchSpreadsheetDataError: 'FETCH_SPREADSHEET_DATA_ERROR',
  SelectRange: 'SELECT_RANGE',
  SelectRangeSuccess: 'SELECT_RANGE_SUCCESS',
  SelectRangeError: 'SELECT_RANGE_ERROR',
  Disconnect: 'DISCONNECT',
  OpenOnboarding: 'OPEN_ONBOARDING',
  OpenExportContactsWizardModal: 'OPEN_EXPORT_CONTACTS_WIZARD_MODAL',
  OpenExportContactsWizardSidebar: 'OPEN_EXPORT_CONTACTS_WIZARD_SIDEBAR',
  OpenModal: 'OPEN_MODAL',
  OpenSidebar: 'OPEN_SIDEBAR',
  CancelImport: 'CANCEL_IMPORT',
  SelectRowInSpreadsheetByEmail: 'SELECT_ROW_IN_SPREADSHEET_BY_EMAIL',
  SelectRowInSpreadsheetByEmailSuccess: 'SELECT_ROW_IN_SPREADSHEET_BY_EMAIL_SUCCESS',
  SelectRowInSpreadsheetByEmailError: 'SELECT_ROW_IN_SPREADSHEET_BY_EMAIL_ERROR',
  WriteToSpreadsheetCell: 'WRITE_TO_SPREADSHEET_CELL',
  WriteToSpreadsheetCellSuccess: 'WRITE_TO_SPREADSHEET_CELL_SUCCESS',
  WriteToSpreadsheetCellError: 'WRITE_TO_SPREADSHEET_CELL_ERROR',
  WriteToSpreadsheetRange: 'WRITE_TO_SPREADSHEET_RANGE',
  WriteToSpreadsheetRangeSuccess: 'WRITE_TO_SPREADSHEET_RANGE_SUCCESS',
  WriteToSpreadsheetRangeError: 'WRITE_TO_SPREADSHEET_RANGE_ERROR',
  GetGoogleEmail: 'GET_GOOGLE_EMAIL',
  GoogleEmailResponse: 'GOOGLE_EMAIL_RESPONSE',
  GoogleEmailError: 'GOOGLE_EMAIL_ERROR',
  // Assistant
  GetDataForA1Notation: 'GET_DATA_FOR_A1_NOTATION',
  GetDataForA1NotationSuccess: 'GET_DATA_FOR_A1_NOTATION_SUCCESS',
  GetDataForA1NotationError: 'GET_DATA_FOR_A1_NOTATION_ERROR',
  FetchDataForAssistant: 'FETCH_DATA_FOR_ASSISTANT',
  FetchDataForAssistantSuccess: 'FETCH_DATA_FOR_ASSISTANT_SUCCESS',
  FetchDataForAssistantError: 'FETCH_DATA_FOR_ASSISTANT_ERROR',
  SetNoteForA1Notation: 'SET_NOTE_FOR_A1_NOTATION',
  SetNoteForA1NotationSuccess: 'SET_NOTE_FOR_A1_NOTATION_SUCCESS',
  SetNoteForA1NotationError: 'SET_NOTE_FOR_A1_NOTATION_ERROR',
  SelectA1Notation: 'SELECT_A1_NOTATION',
  SelectA1NotationSuccess: 'SELECT_A1_NOTATION_SUCCESS',
  SelectA1NotationError: 'SELECT_A1_NOTATION_ERROR',
  EditIndividualCells: 'EDIT_INDIVIDUAL_CELLS',
  EditIndividualCellsSuccess: 'EDIT_INDIVIDUAL_CELLS_SUCCESS',
  EditIndividualCellsError: 'EDIT_INDIVIDUAL_CELLS_ERROR',
  ResetOnboardingFlag: 'RESET_ONBOARDING_FLAG',
  ResetOnboardingFlagSuccess: 'RESET_ONBOARDING_FLAG_SUCCESS',
  ResetOnboardingFlagError: 'RESET_ONBOARDING_FLAG_ERROR'
};